import H3 from "@material-tailwind/react/Heading3";
import React from 'react';
import Fade from 'react-reveal/Fade';
import inheritance from '../images/inheritance.jfif';
import solid from '../images/solid.jfif';
import superInJava from '../images/super.jfif';
import BlogCard from "./BlogCard";

const Blogs = () => {
    const myBlogs = [
        {
            name: "What is SOLID?",
            image: solid,
            description: "SOLID is a series of principles that you must abide by to keep your code",
            link: "https://shakibuddinbhuiyan.medium.com/what-are-solid-design-principles-2fb608755fd1"
        },
        {
            name: "Super in Java",
            image: superInJava,
            description: "In Java, there is a keyword called super. It has many functionalities.",
            link: "https://shakibuddinbhuiyan.medium.com/super-in-java-ef121c7a63b5"
        },
        {
            name: "What is inheritance?",
            image: inheritance,
            description: "Let’s explain with an example from the Marvel Cinematic universe.",
            link: "https://shakibuddinbhuiyan.medium.com/what-is-inheritance-a3756c82cfea"
        }
    ];
    return (
        <div id="blogs" className='w-full min-h-screen p-4'>
            <H3 color="lightBlue">Blogs</H3>
            <div className='w-full grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 pt-8'>
                {
                    myBlogs.map((blog, index) => {
                        if (index % 2 === 0) {
                            return <Fade bottom><BlogCard key={index} data={blog}></BlogCard></Fade>
                        }
                        else {
                            return <Fade top><BlogCard key={index} data={blog}></BlogCard></Fade>
                        }
                    })
                }
            </div>

        </div>
    );
};

export default Blogs;